/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import Logo from "./logo.png";
import zIndex from "@mui/material/styles/zIndex";
import { useNavigate } from "react-router-dom";

function Header() {
  const handleChangePassword = () => {
    // navigate("/change-password");
  };
  function handleLogoutPopup() {
    sessionStorage.clear();
    window.location = "/Login";
  }
  useEffect(() => {}, []);
  return (
    <>
      <nav
        className="navbar navbar-inverse navbar-expand-lg navbar-light bg-light "
        style={{ zIndex: 1000 }}
      >
        <div className="container-fluid">
          <div className="navbar-header">
            <a className="navbar-brand" href="/">
              <img src={Logo} width="100px" alt="adi-mahesh-logo" />
            </a>
          </div>
          <div className="nav navbar-nav navbar-right">
            {sessionStorage.getItem("token") ? (
              <>
                <ul className="navbar-nav mr-2">
                  <li className="nav-item dropdown">
                    <a
                      href="#"
                      className="nav-link dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <b>{sessionStorage.getItem("name")}</b>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        href="#"
                        className="dropdown-item"
                        onClick={(e) => {
                          handleChangePassword();
                        }}
                      >
                        Change password
                      </a>
                      <a
                        href="#"
                        className="dropdown-item"
                        onClick={(e) => {
                          handleLogoutPopup();
                        }}
                      >
                        Sign out
                      </a>
                    </div>
                  </li>
                </ul>
              </>
            ) : (
              <form className="form-inline my-2 my-lg-0">
                <a className="btn my-2 my-sm-0" type="submit" href="Login">
                  Login
                </a>
              </form>
            )}
          </div>
        </div>
      </nav>
    </>
  );
}
export default Header;
